import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AwaitModules, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_HomeScores.scss';
import { ScoreData } from '../../../../_utils/ScoreData.js';
import { exists, filterDuplicates, filterInstances } from '@nu-art/ts-common';
import { AdvisorConfigKeyFE_IndependentScores, ModuleFE_Advisor_Action, ModuleFE_Advisor_DiseaseProfile, ModuleFE_Advisor_OrderGroup, ModuleFE_Advisor_Pathway, ModuleFE_Advisor_PathwayState, ModuleFE_Advisor_PathwayTransition, ModuleFE_Advisor_Variable, ModuleFE_RuntimeFinding, ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { Renderer_Score } from '../../../panels/AdvisorPanel_NextSteps/Renderer_Score/Renderer_Score.js';
import { ProtocolData } from '../../../../_utils/ProtocolData/ProtocolData.js';
import { ProtocolListAssignment } from '@app/advisor-shared';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { Component_AdvisorSL_HomeScores } from '../../../loaders/skeleton/home-scores/Component_AdvisorSL_HomeScores.js';
const modulesToAwait = [
    //Static Modules
    ModuleFE_Advisor_Pathway,
    ModuleFE_Advisor_PathwayState,
    ModuleFE_Advisor_PathwayTransition,
    ModuleFE_Advisor_DiseaseProfile,
    ModuleFE_Advisor_Variable,
    ModuleFE_Advisor_Action,
    ModuleFE_Advisor_OrderGroup,
    //Runtime Modules
    ModuleFE_RuntimeProtocol,
    ModuleFE_RuntimeFinding,
];
export class Component_HomeScores_Class extends ComponentSync {
    //######################### Life Cycle #########################
    __onRuntimeFindingsUpdated = (...params) => this.forceUpdate();
    deriveStateFromProps(nextProps, state) {
        state.scoreData = this.getScoreData();
        return state;
    }
    componentDidMount() {
        ModuleFE_AdvisorAnalytics.trigger.uiLoad.uiLoad_keyScores({
            elapsed_ms: ModuleFE_AdvisorAnalytics.getTimeSinceLoad()
        });
    }
    //######################### Logic #########################
    getTopProtocols() {
        const hcProtocols = ModuleFE_RuntimeProtocol.cache.filter(p => p.listAssignment === ProtocolListAssignment.CONSIDER_NOW);
        return filterInstances(hcProtocols.map(p => ProtocolData.createNew(p._id)));
    }
    getScoreData() {
        const topProtocols = this.getTopProtocols();
        const scoreData = [];
        const independentScoreReferences = AdvisorConfigKeyFE_IndependentScores.get();
        if (independentScoreReferences)
            scoreData.push(...filterInstances(independentScoreReferences.map(ref => ScoreData.createNew(ref))));
        const protocolsScores = topProtocols.map(p => p.scoreData).flat();
        scoreData.push(...protocolsScores);
        return filterDuplicates(scoreData, score => score.getScoreReference().variableId);
    }
    //######################### Render #########################
    render() {
        if (!this.state.scoreData.some(data => exists(data.getValue())))
            return;
        return _jsxs(LL_V_L, { className: 'home__scores', children: [_jsx("h1", { children: "Key Scores" }), _jsx(LL_H_C, { className: 'home__scores__scores', children: this.state.scoreData.map(data => {
                        const value = data.getValue();
                        const partialValue = data.getPartialValue();
                        if (!exists(value) && !exists(partialValue))
                            return;
                        return _jsx(Renderer_Score, { scoreData: data }, data.getScoreReference().variableId);
                    }) })] });
    }
}
export const Component_HomeScores = () => _jsx(AwaitModules, { modules: modulesToAwait, Component: () => _jsx(Component_HomeScores_Class, {}), customLoader: _jsx(Component_AdvisorSL_HomeScores, {}) });
//# sourceMappingURL=Component_HomeScores.js.map